import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../config/axios';
import { toast, ToastContainer } from 'react-toastify';
import { Addbutton, CSSForSelect, CSSForSelect15vWWidth, CSSForSelect23vWWidth, CSSForSelectModern, DeleteButton, formatCurrencyIndian, handleErrorToast, ProgressModal, Updatebutton } from '../CustomFunctions';
import { AddButton, AddwithWhiteCircle, DeleteDustbin, UpdatePencil } from '../AllSvg';
import { Modal } from 'react-bootstrap';
import Select, { components } from "react-select";
import { Wallet, Filter, Tag, Briefcase, FileText, Clock, Calendar, Landmark, ChevronUp, ChevronDown, Sparkles, Save, Loader, X, Building2, MapPin, Users, IndianRupee, Trash2, AlertCircle } from 'lucide-react';
import { AddDynamicButton } from '../SiteManagement/Components/modernbuttons/AddDynamicButton';

// const AddUpdateImprestDetails = ({
//     getData,
//     usedfor,
//     i,
//     projectLists,
// }) => {

//     const siteprojectId = sessionStorage.getItem('sitemanagement_project');
//     const role = sessionStorage.getItem('sitemanagement_role');
//     const employeeId = sessionStorage.getItem('sitemanagement_emp_id');
//     const [projectId, setProjectId] = useState(siteprojectId ? siteprojectId : "null");
//     const [projectList, setProjectList] = useState([]);
//     const [employeeList, setEmployeeList] = useState([]);
//     const [employeeIdd, setEmployeeID] = useState("null")
//     const [show, setShow] = useState(false);
//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});
//     const [employeeListbyId, setEmployeeListbyId] = useState({});
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);
//     const [loading, setLoading] = useState(false);

//     const getProjectdata = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${role === "AuthorityEngineer" ? employeeId : "null"}/null/${role === "DataEntryOperator" ? employeeId : "null"}/null/`);
//             setProjectList(response.data);
//         } catch (error) {
//             console.error(error);

//         }
//     }

//     const getEmployeebySite = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/${projectId}/`);
//             setEmployeeList(response.data);
//         } catch (error) {
//             console.error(error);

//         }
//     };
//     const getEmployeebySitebYID = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/employeebyempid/${employeeIdd}/`);
//             setEmployeeListbyId(response.data);
//         } catch (error) {
//             console.error(error);

//         }
//     };

//     useEffect(() => {
//         if (show === true) {
//             getProjectdata();
//             if (projectId !== "null") {
//                 getEmployeebySite();
//             }
//             if (employeeIdd !== "null") {
//                 getEmployeebySitebYID();
//             }
//         }
//     }, [show, projectId, role, employeeIdd, employeeIdd]);


//     const [formData, setFormData] = useState({
//         total_number_officesite: "",
//         fixed_imprest_amount: "",
//         bank_name: "",
//         account_holder_name: "",
//         account_number: "",
//         ifsc_code: "",
//         pan_card: "",
//         phone_number: "",
//         site_project: "",
//         employee: "",

//     })



//     const handleShow = () => {
//         setShow(true);
//         if (usedfor === "Edit" && i) {
//             setFormData(i);
//             setProjectId(i.site_project ? i.site_project : "null");
//             setEmployeeID(i.employee ? i.employee : "null");
//         }
//     }

//     const handleClose = () => {
//         setShow(false);
//         setFormData({
//             total_number_officesite: "",
//             fixed_imprest_amount: "",
//             bank_name: "",
//             account_holder_name: "",
//             account_number: "",
//             ifsc_code: "",
//             pan_card: "",
//             phone_number: "",
//             site_project: "",
//             employee: "",
//         });
//         setProjectId(siteprojectId ? siteprojectId : "null");
//     };


//     const validateForm = () => {
//         const newErrors = {};

//         if (!formData.total_number_officesite) {
//             newErrors.total_number_officesite = "This field is required!";
//         }
//         if (!formData.fixed_imprest_amount) {
//             newErrors.fixed_imprest_amount = "This field is required!";
//         }
//         if (employeeIdd === "null") {
//             newErrors.employeeIdd = "This field is required!";
//         }
//         if (projectId === "null") {
//             newErrors.projectId = "This field is required!";
//         }


//         setErrors(newErrors);

//         if (Object.keys(newErrors).length > 0) {
//             toast.dismiss();
//             toast.warn("Fill all * fields");
//             return false;
//         }

//         return true;
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         const capitalizeFields = [
//             "ifsc_code",
//             "account_number",
//             "account_holder_name",
//             "bank_name",
//             "ifsc_code",
//         ];

//         const finalValue = capitalizeFields.includes(name)
//             ? value.toUpperCase()
//             : value;

//         setInputState({
//             ...inputState,
//             [name]: finalValue.trim() ? "green" : "",
//         });

//         const updatedFormData = {
//             ...formData,
//             [name]: finalValue,
//         };
//         setFormData(updatedFormData);

//         if (errors[name]) {
//             setErrors((prevErrors) => {
//                 const newErrors = { ...prevErrors };
//                 delete newErrors[name];
//                 return newErrors;
//             });
//         }
//     };

//     const usedProjectIds = projectLists?.map(item => item.site_project) || [];


//     const employeeOptions = employeeList
//         .sort((a, b) => a.emp_code - b.emp_code)
//         .map(emp => ({
//             value: emp.id,
//             label: `${emp.emp_code} - ${emp.name}`,
//         }));
//     const projectOptions = projectList
//         .filter(project => !usedProjectIds.includes(project.id))
//         .sort((a, b) => a.site_prcode - b.site_prcode)
//         .map(project => ({
//             value: project.id,
//             label: `${project.site_prcode} - ${project.project_short_name}`,
//         }));

//     const handleProjectOptions = (option) => {
//         if (!option) {
//             setProjectId("null");
//         }
//         else {
//             setProjectId(option.value);
//         }
//     }
//     const handleEmployeeChange = (option) => {
//         if (!option) {
//             setEmployeeID("null");
//         }
//         else {
//             setEmployeeID(option.value);
//         }
//     };


//     useEffect(() => {
//         if (employeeIdd !== "null") {
//             setFormData((prev) => ({
//                 ...prev,
//                 employee: employeeIdd,

//                 bank_name: String(employeeListbyId?.bank_name || "").toUpperCase(),
//                 account_holder_name: String(employeeListbyId?.account_holder_name || "").toUpperCase(),

//                 // Numbers → keep as string (NO toUpperCase needed)
//                 account_number: String(employeeListbyId?.account_number || ""),
//                 phone_number: String(employeeListbyId?.mobile || ""),

//                 // These SHOULD be uppercase
//                 ifsc_code: String(employeeListbyId?.ifsc_code || "").toUpperCase(),
//                 pan_card: String(employeeListbyId?.pan || "").toUpperCase(),
//             }));
//         }

//         if (projectId !== "null") {
//             setFormData((prev) => ({
//                 ...prev,
//                 site_project: projectId,
//             }));
//         }
//     }, [employeeIdd, employeeListbyId, projectId]);








//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setShowProgressModal(true);
//             setLoading(true);
//             setUploadProgress(0);
//             let loadingToastId = null;

//             if (usedfor === "Edit") {
//                 loadingToastId = toast.loading("Updating: please wait...");
//             }
//             else if (usedfor === "Add") {
//                 loadingToastId = toast.loading("Uploading: please wait...");

//             }
//             let progress = 0;
//             const interval = setInterval(() => {
//                 progress += 10;
//                 if (progress >= 100) {
//                     progress = 100;
//                     clearInterval(interval);
//                 }
//                 setUploadProgress(progress);
//             }, 100);

//             try {
//                 let res = null;
//                 if (usedfor === "Edit") {
//                     res = await axios.put(`${BASE_URL}/siteproject/imprestbankdetails/${i.id}/`, formData);
//                 } else if (usedfor === "Add") {
//                     res = await axios.post(`${BASE_URL}/siteproject/imprestbankdetails/`, formData);
//                 }

//                 if (res.status === 200) {
//                     await getData();
//                     handleClose();
//                     if (usedfor === "Edit") {
//                         setTimeout(() => {
//                             toast.dismiss(loadingToastId);
//                             toast.success("Details updated successfully.", {
//                                 autoClose: 1000,
//                                 pauseOnHover: true,
//                                 closeOnClick: true,
//                             });
//                         }, 1000);
//                     } else if (usedfor === "Add") {
//                         setTimeout(() => {
//                             toast.dismiss(loadingToastId);
//                             toast.success("Imprest details added successfully.", {
//                                 autoClose: 1000,
//                                 pauseOnHover: true,
//                                 closeOnClick: true,
//                             });
//                         }, 1000);
//                     }
//                 } else {
//                     throw new Error("Unexpected response status: " + res.status);
//                 }

//             } catch (err) {
//                 clearInterval(interval);
//                 setUploadProgress(0);
//                 handleErrorToast(err);
//             } finally {
//                 clearInterval(interval);

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 1500);

//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }
//         }

//     }

//     useEffect(() => {
//         if (formData.site_project !== projectId) {

//             setFormData((prev) => ({
//                 ...prev,
//                 employee: "null",
//                 bank_name: "",
//                 account_holder_name: "",
//                 account_number: "",
//                 ifsc_code: "",
//                 pan_card: "",
//                 phone_number: "",
//             }))
//             setEmployeeID("null");
//         }
//     }, [formData.site_project, projectId]);
//     return (
//         <>
//             {usedfor === "Add" ?
//                 <button
//                     className="clearbutton"
//                     onClick={handleShow}
//                     style={{
//                         padding: "10px"
//                     }}
//                 >
//                     <span className="transition"></span>
//                     <span className="gradient"></span>
//                     <span className="label"><AddwithWhiteCircle />Imprest Details</span>
//                 </button> :
//                 usedfor === "Edit" &&
//                 <button title='Update Imprest Details' className='model-edit-button' onClick={handleShow}>

//                     <UpdatePencil />
//                 </button>
//             }
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor={usedfor === "Add" ? "Add" : "Update"} /> :
//                     show === true ?
//                         <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//                             <Modal.Header closeButton>
//                                 <Modal.Title>{usedfor === "Add" ? "Add Imprest Detail" : "Update Imprest Detail"}</Modal.Title>
//                             </Modal.Header>
//                             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//                             <Modal.Body>
//                                 <div className='bdy-div'>
//                                     <div className="form-flex-wrap">
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading"
//                                                 title="Site Project">Site Project<span className="required">{role === "SiteManagement" || usedfor === "Edit" ? "(Read-Only)" : "*"}</span></label>
//                                             <Select
//                                                 options={projectOptions}
//                                                 isSearchable
//                                                 isClearable
//                                                 isDisabled={role === "SiteManagement" || usedfor === "Edit" ? true : false}
//                                                 placeholder="Select"
//                                                 value={projectOptions.find(
//                                                     opt => opt.value === projectId
//                                                 )}
//                                                 onChange={handleProjectOptions}
//                                                 styles={CSSForSelect}
//                                             />
//                                             {errors.projectId && <span className="error-message font-size-text">{errors.projectId}</span>}
//                                         </div>

//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Number of office staff">Number of office staff<span className="required">*</span></label>
//                                             <input
//                                                 type="number"
//                                                 name="total_number_officesite"
//                                                 title="Number of office staff"
//                                                 placeholder='Number of office staff'
//                                                 value={formData.total_number_officesite}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.total_number_officesite ? "error" : inputState.total_number_officesite ? "success" : ""}`}
//                                             />
//                                             {errors.total_number_officesite && <span className="error-message font-size-text">{errors.total_number_officesite}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Fixed Imprest Amount">Fixed Imprest Amount<span className="required">*</span></label>
//                                             <input
//                                                 type="number"
//                                                 name="fixed_imprest_amount"
//                                                 title="Fixed Imprest Amount"
//                                                 placeholder='Fixed Imprest Amount'
//                                                 value={formData.fixed_imprest_amount}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.fixed_imprest_amount ? "error" : inputState.fixed_imprest_amount ? "success" : ""}`}
//                                             />
//                                             {errors.fixed_imprest_amount && <span className="error-message font-size-text">{errors.fixed_imprest_amount}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading"
//                                                 title="Select Employee">Employee<span className="required">{projectId === "null" ? "(Select Project First)" : "*"}</span></label>
//                                             < Select
//                                                 options={employeeOptions}
//                                                 isSearchable
//                                                 isClearable
//                                                 placeholder="Select"
//                                                 value={employeeOptions.find(
//                                                     opt => opt.value === employeeIdd
//                                                 )}
//                                                 onChange={handleEmployeeChange}
//                                                 styles={CSSForSelect}
//                                             />
//                                             {errors.employeeIdd && <span className="error-message font-size-text">{errors.employeeIdd}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Bank Name">Bank Name <br /><span className="required">(Read-Only)</span></label>
//                                             <input
//                                                 type="text"
//                                                 name="bank_name"
//                                                 title="Bank Name"
//                                                 placeholder='Bank Name'
//                                                 value={formData.bank_name}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.bank_name ? "error" : inputState.bank_name ? "success" : ""}`}
//                                                 readOnly
//                                             />
//                                             {errors.bank_name && <span className="error-message font-size-text">{errors.bank_name}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Account Holder Name">Account Holder Name <br /><span className="required">(Read-Only)</span></label>
//                                             <input
//                                                 type="text"
//                                                 name="account_holder_name"
//                                                 title="Account Holder Name"
//                                                 placeholder='Account Holder Name'
//                                                 value={formData.account_holder_name}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.account_holder_name ? "error" : inputState.account_holder_name ? "success" : ""}`}
//                                                 readOnly
//                                             />
//                                             {errors.account_holder_name && <span className="error-message font-size-text">{errors.account_holder_name}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Account Number">Account Number<span className="required">(Read-Only)</span></label>
//                                             <input
//                                                 type="text"
//                                                 name="account_number"
//                                                 title="Account Number"
//                                                 placeholder='Account Number'
//                                                 value={formData.account_number}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.account_number ? "error" : inputState.account_number ? "success" : ""}`}
//                                                 readOnly
//                                             />
//                                             {errors.account_number && <span className="error-message font-size-text">{errors.account_number}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="IFSC Code">IFSC Code<span className="required">(Read-Only)</span></label>
//                                             <input
//                                                 type="text"
//                                                 name="ifsc_code"
//                                                 title="IFSC Code"
//                                                 placeholder='IFSC Code'
//                                                 value={formData.ifsc_code}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.ifsc_code ? "error" : inputState.ifsc_code ? "success" : ""}`}
//                                                 readOnly
//                                             />
//                                             {errors.ifsc_code && <span className="error-message font-size-text">{errors.ifsc_code}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="PAN Number">PAN Number<span className="required">(Read-Only)</span></label>
//                                             <input
//                                                 type="text"
//                                                 name="pan_card"
//                                                 title="PAN Number"
//                                                 placeholder='PAN Number'
//                                                 value={formData.pan_card}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.pan_card ? "error" : inputState.pan_card ? "success" : ""}`}
//                                                 readOnly
//                                             />
//                                             {errors.pan_card && <span className="error-message font-size-text">{errors.pan_card}</span>}
//                                         </div>
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Phone Number">Phone Number<span className="required">(Read-Only)</span></label>
//                                             <input
//                                                 type="number"
//                                                 name="phone_number"
//                                                 title="Phone Number"
//                                                 placeholder='Phone Number'
//                                                 value={formData.phone_number}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input-date width-15vw ${errors.phone_number ? "error" : inputState.phone_number ? "success" : ""}`}
//                                                 readOnly
//                                             />
//                                             {errors.phone_number && <span className="error-message font-size-text">{errors.phone_number}</span>}
//                                         </div>


//                                     </div>
//                                 </div>










//                                 <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
//                                     <button className="cancelbutton" onClick={handleClose}>Cancel</button>
//                                     {
//                                         usedfor === "Add" ?

//                                             <Addbutton onclick={handleSubmit} /> :
//                                             usedfor === "Edit" &&
//                                             <Updatebutton onclick={handleSubmit} />
//                                     }
//                                 </div>
//                                 <ToastContainer
//                                     position="top-center"
//                                     autoClose={1000}
//                                     hideProgressBar={false}
//                                     newestOnTop={true}
//                                     closeOnClick
//                                     rtl={false}
//                                     pauseOnFocusLoss
//                                     draggable
//                                     pauseOnHover
//                                 />
//                             </Modal.Body>
//                         </Modal> : ""
//             }
//         </>
//     );
// }
const AddUpdateImprestDetails = ({
    getData,
    usedfor,
    i,
    projectLists,
}) => {

    const siteprojectId = sessionStorage.getItem('sitemanagement_project');
    const role = sessionStorage.getItem('sitemanagement_role');
    const employeeId = sessionStorage.getItem('sitemanagement_emp_id');
    const [projectId, setProjectId] = useState(siteprojectId ? siteprojectId : "null");
    const [projectList, setProjectList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [employeeIdd, setEmployeeID] = useState("null")
    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [employeeListbyId, setEmployeeListbyId] = useState({});
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const getProjectdata = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${role === "AuthorityEngineer" ? employeeId : "null"}/null/${role === "DataEntryOperator" ? employeeId : "null"}/null/`);
            setProjectList(response.data);
        } catch (error) {
            console.error(error);

        }
    }

    const getEmployeebySite = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/${projectId}/`);
            setEmployeeList(response.data);
        } catch (error) {
            console.error(error);

        }
    };
    const getEmployeebySitebYID = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/employeebyempid/${employeeIdd}/`);
            setEmployeeListbyId(response.data);
        } catch (error) {
            console.error(error);

        }
    };

    useEffect(() => {
        if (show === true) {
            getProjectdata();
            if (projectId !== "null") {
                getEmployeebySite();
            }
            if (employeeIdd !== "null") {
                getEmployeebySitebYID();
            }
        }
    }, [show, projectId, role, employeeIdd, employeeIdd]);


    const [formData, setFormData] = useState({
        total_number_officesite: "",
        fixed_imprest_amount: "",
        bank_name: "",
        account_holder_name: "",
        account_number: "",
        ifsc_code: "",
        pan_card: "",
        phone_number: "",
        site_project: "",
        employee: "",

    })



    const handleShow = () => {
        setShow(true);
        if (usedfor === "Edit" && i) {
            setFormData(i);
            setProjectId(i.site_project ? i.site_project : "null");
            setEmployeeID(i.employee ? i.employee : "null");
        }
    }

    const handleClose = () => {
        setShow(false);
        setErrors({});
        setInputState({});
        setFormData({
            total_number_officesite: "",
            fixed_imprest_amount: "",
            bank_name: "",
            account_holder_name: "",
            account_number: "",
            ifsc_code: "",
            pan_card: "",
            phone_number: "",
            site_project: "",
            employee: "",
        });
        setProjectId(siteprojectId ? siteprojectId : "null");
        setEmployeeID("null");
    };


    const validateForm = () => {
        const newErrors = {};

        if (!formData.total_number_officesite) {
            newErrors.total_number_officesite = "This field is required!";
        }
        if (!formData.fixed_imprest_amount) {
            newErrors.fixed_imprest_amount = "This field is required!";
        }
        if (employeeIdd === "null") {
            newErrors.employeeIdd = "This field is required!";
        }
        if (projectId === "null") {
            newErrors.projectId = "This field is required!";
        }


        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            toast.dismiss();
            toast.warn("Fill all * fields");
            return false;
        }

        return true;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        const capitalizeFields = [
            "ifsc_code",
            "account_number",
            "account_holder_name",
            "bank_name",
            "ifsc_code",
        ];

        const finalValue = capitalizeFields.includes(name)
            ? value.toUpperCase()
            : value;

        setInputState({
            ...inputState,
            [name]: finalValue.trim() ? "green" : "",
        });

        const updatedFormData = {
            ...formData,
            [name]: finalValue,
        };
        setFormData(updatedFormData);

        if (errors[name]) {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const usedProjectIds = projectLists?.map(item => item.site_project) || [];


    const employeeOptions = employeeList
        .sort((a, b) => a.emp_code - b.emp_code)
        .map(emp => ({
            value: emp.id,
            label: `${emp.emp_code} - ${emp.name}`,
        }));
    const projectOptions = projectList
        .filter(project => !usedProjectIds.includes(project.id))
        .sort((a, b) => a.site_prcode - b.site_prcode)
        .map(project => ({
            value: project.id,
            label: `${project.site_prcode} - ${project.project_short_name}`,
        }));

    const handleProjectOptions = (option) => {
        if (!option) {
            setProjectId("null");
        }
        else {
            setProjectId(option.value);
        }
    }
    const handleEmployeeChange = (option) => {
        if (!option) {
            setEmployeeID("null");
        }
        else {
            setEmployeeID(option.value);
        }
    };


    useEffect(() => {
        if (employeeIdd !== "null") {
            setFormData((prev) => ({
                ...prev,
                employee: employeeIdd,

                bank_name: String(employeeListbyId?.bank_name || "").toUpperCase(),
                account_holder_name: String(employeeListbyId?.account_holder_name || "").toUpperCase(),

                // Numbers → keep as string (NO toUpperCase needed)
                account_number: String(employeeListbyId?.account_number || ""),
                phone_number: String(employeeListbyId?.mobile || ""),

                // These SHOULD be uppercase
                ifsc_code: String(employeeListbyId?.ifsc_code || "").toUpperCase(),
                pan_card: String(employeeListbyId?.pan || "").toUpperCase(),
            }));
        }

        if (projectId !== "null") {
            setFormData((prev) => ({
                ...prev,
                site_project: projectId,
            }));
        }
    }, [employeeIdd, employeeListbyId, projectId]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setShowProgressModal(true);
            setLoading(true);
            setUploadProgress(0);
            let loadingToastId = null;

            if (usedfor === "Edit") {
                loadingToastId = toast.loading("Updating: please wait...");
            }
            else if (usedfor === "Add") {
                loadingToastId = toast.loading("Uploading: please wait...");

            }
            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                let res = null;
                if (usedfor === "Edit") {
                    res = await axios.put(`${BASE_URL}/siteproject/imprestbankdetails/${i.id}/`, formData);
                } else if (usedfor === "Add") {
                    res = await axios.post(`${BASE_URL}/siteproject/imprestbankdetails/`, formData);
                }

                if (res.status === 200) {
                    await getData();
                    handleClose();
                    if (usedfor === "Edit") {
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Details updated successfully.", {
                                autoClose: 1000,
                                pauseOnHover: true,
                                closeOnClick: true,
                            });
                        }, 1000);
                    } else if (usedfor === "Add") {
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Imprest details added successfully.", {
                                autoClose: 1000,
                                pauseOnHover: true,
                                closeOnClick: true,
                            });
                        }, 1000);
                    }
                } else {
                    throw new Error("Unexpected response status: " + res.status);
                }

            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleErrorToast(err);
            } finally {
                clearInterval(interval);

                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);

                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }

    }

    useEffect(() => {
        if (formData.site_project !== projectId) {

            setFormData((prev) => ({
                ...prev,
                employee: "null",
                bank_name: "",
                account_holder_name: "",
                account_number: "",
                ifsc_code: "",
                pan_card: "",
                phone_number: "",
            }))
            setEmployeeID("null");
        }
    }, [formData.site_project, projectId]);

    return (
        <>
            {usedfor === "Add" ? (
                <button title="Add Imprest Details" className="btn-animated" onClick={handleShow}>
                    <AddwithWhiteCircle /> Imprest Details
                </button>
            ) : (
                usedfor === "Edit" && (
                    <button title='Update Imprest Details' className="model-edit-button-modern actionn-icon" style={{ background: "#00000075" }} onClick={handleShow}>
                        <UpdatePencil modernButton="true" />
                    </button>
                )
            )}

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor={usedfor === "Add" ? "Add" : "Update"} />
            ) : show === true && (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Landmark size={24} />
                            </div>
                            <div>
                                <Modal.Title>{usedfor === "Add" ? "Add Imprest Detail" : "Update Imprest Detail"}</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Configure imprest bank details for a site project</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="form-section">
                            <div className="section-title">
                                <MapPin size={18} />
                                <h4>Project & Employee</h4>
                            </div>

                            <div className="form-grid">
                                <div className="form-field">
                                    <label><MapPin size={14} /> Site Project<span className="required">{role === "SiteManagement" || usedfor === "Edit" ? " (Read-Only)" : "*"}</span></label>
                                    <Select
                                        options={projectOptions}
                                        isSearchable
                                        isClearable
                                        isDisabled={role === "SiteManagement" || usedfor === "Edit" ? true : false}
                                        placeholder="Select"
                                        value={projectOptions.find(opt => opt.value === projectId)}
                                        onChange={handleProjectOptions}
                                        styles={CSSForSelectModern}
                                    />
                                    {errors.projectId && <span className="error-message">{errors.projectId}</span>}
                                </div>

                                <div className="form-field">
                                    <label><Users size={14} /> Employee<span className="required">{projectId === "null" ? " (Select Project First)" : "*"}</span></label>
                                    <Select
                                        options={employeeOptions}
                                        isSearchable
                                        isClearable
                                        placeholder="Select"
                                        value={employeeOptions.find(opt => opt.value === employeeIdd)}
                                        onChange={handleEmployeeChange}
                                        styles={CSSForSelectModern}
                                    />
                                    {errors.employeeIdd && <span className="error-message">{errors.employeeIdd}</span>}
                                </div>

                                <div className="form-field">
                                    <label><Users size={14} /> Number of Office Staff<span className="required">*</span></label>
                                    <input
                                        type="number"
                                        name="total_number_officesite"
                                        placeholder="Number of office staff"
                                        value={formData.total_number_officesite}
                                        onChange={handleInputChange}
                                        className={errors.total_number_officesite ? "error" : inputState.total_number_officesite ? "success" : ""}
                                    />
                                    {errors.total_number_officesite && <span className="error-message">{errors.total_number_officesite}</span>}
                                </div>

                                <div className="form-field">
                                    <label><IndianRupee size={14} /> Fixed Imprest Amount<span className="required">*</span></label>
                                    <input
                                        type="number"
                                        name="fixed_imprest_amount"
                                        placeholder="Fixed Imprest Amount"
                                        value={formData.fixed_imprest_amount}
                                        onChange={handleInputChange}
                                        className={errors.fixed_imprest_amount ? "error" : inputState.fixed_imprest_amount ? "success" : ""}
                                    />
                                    {errors.fixed_imprest_amount && <span className="error-message">{errors.fixed_imprest_amount}</span>}
                                </div>
                            </div>
                        </div>

                        <div className="form-section">
                            <div className="section-title">
                                <Landmark size={18} />
                                <h4>Bank Details <span className="required" style={{ fontSize: '11px', textTransform: 'none' }}>(Auto-filled from employee, read-only)</span></h4>
                            </div>

                            <div className="form-grid">
                                <div className="form-field">
                                    <label> Bank Name</label>
                                    <input type="text" name="bank_name" value={formData.bank_name} readOnly style={{ cursor: 'not-allowed' }} />
                                </div>

                                <div className="form-field">
                                    <label> Account Holder Name</label>
                                    <input type="text" name="account_holder_name" value={formData.account_holder_name} readOnly style={{ cursor: 'not-allowed' }} />
                                </div>

                                <div className="form-field">
                                    <label> Account Number</label>
                                    <input type="text" name="account_number" value={formData.account_number} readOnly style={{ cursor: 'not-allowed' }} />
                                </div>

                                <div className="form-field">
                                    <label> IFSC Code</label>
                                    <input type="text" name="ifsc_code" value={formData.ifsc_code} readOnly style={{ cursor: 'not-allowed' }} />
                                </div>

                                <div className="form-field">
                                    <label> PAN Number</label>
                                    <input type="text" name="pan_card" value={formData.pan_card} readOnly style={{ cursor: 'not-allowed' }} />
                                </div>

                                <div className="form-field">
                                    <label> Phone Number</label>
                                    <input type="text" name="phone_number" value={formData.phone_number} readOnly style={{ cursor: 'not-allowed' }} />
                                </div>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                Cancel
                            </button>
                            <button type="button" className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                <span>{loading ? (usedfor === "Edit" ? 'Updating...' : 'Adding...') : (usedfor === "Edit" ? 'Update' : 'Add')}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
}



const AddImpresetBulkBilling = ({ getData, imprestDetails, list }) => {
    const [errors, setErrors] = useState({});
    const siteId = sessionStorage.getItem('sitemanagement_project');
    const role = sessionStorage.getItem('sitemanagement_role');
    const [expandedRow, setExpandedRow] = useState(null);

    const initialRow = {
        project: "",
        imprestbank_details: "",
        account_holder_name: "",
        account_number: "",
        ifsc_code: "",
        pan_card: "",
        phone_number: "",
        date: "",
        imprest_name: "",
        fixed_imprest_amount: "",
        total_number_of_Office_staff: "",
        no_of_days: "",
        bank_name: "",
        project_code: "",
        project_short_name: "",
        imprest_open: false,
    };

    const [formData, setFormData] = useState([{ ...initialRow }]);
    const [show, setShow] = useState(false);
    const [projectIds, setProjectIds] = useState([]);
    const [projectId, setProjectId] = useState("null");
    const [BillingType, setBillingType] = useState("null");
    const [commonDate, setCommonDate] = useState("null");
    const [commonDays, setCommonDays] = useState("null");
    const [ImprestName, setImprestName] = useState("null");

    const validateForm = () => {
        const newErrors = {};
        if (commonDate === "null") newErrors.commonDate = "This field is required!";
        if (commonDays === "null") newErrors.commonDays = "This field is required!";
        if (ImprestName === "null") newErrors.ImprestName = "This field is required!";
        if (BillingType === "null") newErrors.BillingType = "This field is required!";
        if (BillingType === "Multiple/All Sites" && projectIds.length === 0) newErrors.projectIds = "This field is required!";
        if (BillingType === "Single Site" && projectId === "null") newErrors.projectId = "This field is required!";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            toast.dismiss();
            toast.warn("Fill all * fields");
            return false;
        }
        return true;
    };

    const Option = (props) => (
        <components.Option {...props}>
            <label title="Star" className="star">
                <input id="star-checkbox" checked={props.isSelected} onChange={() => null} className="checkbox" type="checkbox" />
                <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg-outline" viewBox="0 0 24 24">
                        <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg-filled" viewBox="0 0 24 24">
                        <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" className="svg-celebrate">
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                    </svg>
                </div>
            </label>
            {props.label}
        </components.Option>
    );

    const MenuList = (props) => {
        const { options, selectProps } = props;
        const filteredOptions = options.filter((opt) => opt.label.toLowerCase() !== "other");
        const selectedValues = selectProps.value?.map((i) => i.value) || [];
        const filteredValues = filteredOptions.map((i) => i.value);
        const isAllSelected = filteredValues.every((val) => selectedValues.includes(val));

        const handleToggle = () => {
            if (isAllSelected) {
                const preserveOther = selectProps.value?.filter((i) => i.label.toLowerCase() === "other") || [];
                selectProps.onChange(preserveOther);
            } else {
                const preserveOther = selectProps.value?.filter((i) => i.label.toLowerCase() === "other") || [];
                selectProps.onChange([...filteredOptions, ...preserveOther]);
            }
        };

        return (
            <components.MenuList {...props}>
                <button
                    type="button"
                    onClick={handleToggle}
                    style={{ width: "100%", padding: "8px 0", fontSize: "13px", cursor: "pointer", fontWeight: "600", borderBottom: "1px solid #e3e3e3", background: "white", color: "#667eea" }}
                >
                    {isAllSelected ? "Unselect All" : "Select All"}
                </button>
                {props.children}
            </components.MenuList>
        );
    };

    const handleShow = () => setShow(true);

    const handleClose = () => {
        setShow(false);
        setFormData([{ ...initialRow }]);
        setCommonDate("null");
        setCommonDays("null");
        setImprestName("null");
        if (role !== "SiteManagement") {
            setProjectId("null");
            setBillingType("null");
        }
        setProjectIds([]);
    };

    const [year, setYear] = useState("null");
    const [month, setMonth] = useState("null");

    useEffect(() => {
        if (!commonDate || commonDate === "null") {
            setYear("null");
            setMonth("null");
            return;
        }
        const [y, m] = commonDate.split("-");
        setYear(y);
        setMonth(m);
    }, [commonDate]);

    const projectOptions = imprestDetails
        .sort((a, b) => a.siteproject_prcode - b.siteproject_prcode)
        .map(project => ({ value: project.site_project, label: `${project.siteproject_prcode} - ${project.siteproject_name}` }));

    const handleProjectOptions = (options) => {
        if (!options || options.length === 0) setProjectIds([]);
        else setProjectIds(options.map(opt => opt.value));
    };
    const handleProjectOptionsSingle = (options) => {
        setProjectId(options ? options.value : "null");
    };

    const BillingTypeList = [
        { value: "Single Site", label: "Single Site" },
        { value: "Multiple/All Sites", label: "Multiple/All Sites" },
        { value: "All Sites", label: "All Sites" }
    ];

    const options = BillingTypeList.sort((a, b) => a.label.localeCompare(b.label)).map(i => ({ value: i.value, label: i.label }));

    const handleOptions = (options) => setBillingType(options ? options.value : "null");

    useEffect(() => {
        if (["All Sites", "Single Site", "Multiple/All Sites"].includes(BillingType)) {
            if (BillingType !== "Single Site" && BillingType !== "Multiple/All Sites") {
                setProjectId("null");
            }
            if (BillingType === "All Sites" || BillingType === "Single Site") {
                setProjectIds([]);
            }
            if (BillingType === "Multiple/All Sites" || BillingType === "All Sites") {
                setProjectId("null");
            }
            setFormData([{ ...initialRow, no_of_days: "0" }]);
        }
    }, [BillingType]);

    useEffect(() => {
        if (!imprestDetails || imprestDetails.length === 0) return;

        if (BillingType === "Multiple/All Sites" && projectIds.length > 0) {
            const rows = imprestDetails
                .filter(item => projectIds.includes(item.site_project))
                .map(item => ({
                    project: item.site_project || "", imprestbank_details: item.id || "",
                    account_holder_name: item.account_holder_name || "", account_number: item.account_number || "",
                    ifsc_code: item.ifsc_code || "", pan_card: item.pan_card || "", phone_number: item.phone_number || "",
                    bank_name: item.bank_name || "", project_short_name: item.siteproject_name || "",
                    project_code: item.siteproject_prcode || "", date: "", imprest_name: "",
                    fixed_imprest_amount: item.fixed_imprest_amount || "", total_number_of_Office_staff: item.total_number_officesite || "",
                    no_of_days: "", imprest_open: item.imprest_open ?? false,
                }));
            setFormData(rows);
        }

        if (BillingType === "Single Site" && projectId !== "null") {
            const item = imprestDetails.find(i => i.site_project === projectId);
            if (item) {
                setFormData([{
                    project: item.site_project || "", imprestbank_details: item.id || "",
                    account_holder_name: item.account_holder_name || "", account_number: item.account_number || "",
                    ifsc_code: item.ifsc_code || "", pan_card: item.pan_card || "", phone_number: item.phone_number || "",
                    bank_name: item.bank_name || "", project_short_name: item.siteproject_name || "",
                    project_code: item.siteproject_prcode || "", date: "", imprest_name: "",
                    fixed_imprest_amount: item.fixed_imprest_amount || "", total_number_of_Office_staff: item.total_number_officesite || "",
                    no_of_days: "", imprest_open: item.imprest_open ?? false,
                }]);
            }
        }

        if (BillingType === "All Sites") {
            const rows = imprestDetails.map(item => ({
                project: item.site_project || "", imprestbank_details: item.id || "",
                account_holder_name: item.account_holder_name || "", account_number: item.account_number || "",
                ifsc_code: item.ifsc_code || "", pan_card: item.pan_card || "", phone_number: item.phone_number || "",
                bank_name: item.bank_name || "", date: "", imprest_name: "",
                fixed_imprest_amount: item.fixed_imprest_amount || "", total_number_of_Office_staff: item.total_number_officesite || "",
                no_of_days: "", imprest_open: item.imprest_open ?? false,
                project_short_name: item.siteproject_name || "", project_code: item.siteproject_prcode || "",
            }));
            setFormData(rows);
        }
    }, [BillingType, projectIds, projectId, imprestDetails]);

    useEffect(() => {
        if (role === "SiteManagement" && siteId) {
            setBillingType("Single Site");
            setProjectId(siteId);
            const item = imprestDetails?.find(i => i.site_project === siteId);
            if (item) {
                setFormData([{
                    project: item.site_project || "", imprestbank_details: item.id || "",
                    account_holder_name: item.account_holder_name || "", account_number: item.account_number || "",
                    ifsc_code: item.ifsc_code || "", pan_card: item.pan_card || "", phone_number: item.phone_number || "",
                    bank_name: item.bank_name || "", project_short_name: item.siteproject_name || "",
                    project_code: item.siteproject_prcode || "",
                    date: commonDate !== "null" ? commonDate : "", imprest_name: ImprestName !== "null" ? ImprestName : "",
                    fixed_imprest_amount: item.fixed_imprest_amount || "", total_number_of_Office_staff: item.total_number_officesite || "",
                    no_of_days: commonDays !== "null" ? commonDays : "", imprest_open: item.imprest_open ?? false,
                }]);
            }
        }
    }, [role, siteId, imprestDetails]);

    const [inputState, setInputState] = useState({});

    const handleCommonChange = (e) => {
        const { name, value } = e.target;
        if (name === "date") setCommonDate(value);
        if (name === "no_of_days") setCommonDays(value);
        if (name === "imprest_name") setImprestName(value);

        setFormData(prev =>
            prev.map(row => ({
                ...row,
                [name]: name === "no_of_days" ? (value === "" ? null : Number(value)) : value || null,
            }))
        );
    };

    const handleInputChangee = (e, index) => {
        const { name, value } = e.target;
        setFormData((prev) => prev.map((item, i) => i === index ? { ...item, [name]: value } : item));
    };

    useEffect(() => {
        setCommonDate("null");
        setCommonDays("null");
        setImprestName("null");
    }, [BillingType]);

    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Uploading: please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/bulkimprestcreate/`, formData);
            if (res.status === 200) {
                await getData();
                toast.dismiss(loadingToastId);
                toast.success("Imprest Bill added successfully.", { autoClose: 1000, pauseOnHover: true, closeOnClick: true });
                handleClose();
            } else {
                throw new Error("Unexpected response status: " + res.status);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const toggleRow = (index) => setExpandedRow(expandedRow === index ? null : index);

    const showPreviewTable = projectIds.length !== 0 || projectId !== "null" || BillingType === "All Sites";

    return (
        <>
            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <>
                    <AddDynamicButton title="Generate Monthly Imprest" logo={<Wallet size={19} />} onClick={handleShow} />

                    <Modal onHide={handleClose} show={show} dialogClassName="modern-project-modal" size="xl">
                        <Modal.Header className="modern-modal-header">
                            <div className="header-content">
                                <div style={{ color: "white" }}>
                                    <Wallet size={24} />
                                </div>
                                <div>
                                    <Modal.Title>
                                        Generate Imprest Bills {role === "SiteManagement" && formData.map((i) => `(${i.project_short_name})`)}
                                    </Modal.Title>
                                    <p className="header-subtitle" style={{ color: "white" }}>Bulk-generate imprest bills for selected projects</p>
                                </div>
                            </div>
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Header>

                        <Modal.Body className="modern-modal-body">
                            <div className="form-section">
                                <div className="section-title">
                                    <Filter size={18} />
                                    <h4>Select Criteria</h4>
                                </div>

                                <div className="form-grid">
                                    {role !== "SiteManagement" && (
                                        <div className="form-field">
                                            <label><Tag size={14} /> Bill Type<span className="required">*</span></label>
                                            <Select
                                                options={options}
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                placeholder="Select Bill Type"
                                                onChange={handleOptions}
                                                value={options.find(opt => opt.value === BillingType) || null}
                                                styles={CSSForSelectModern}
                                            />
                                            {errors.BillingType && <span className="error-message">{errors.BillingType}</span>}
                                        </div>
                                    )}

                                    {(BillingType !== "All Sites" && BillingType !== "null" && role !== "SiteManagement") && (
                                        <div className="form-field">
                                            <label><Briefcase size={14} /> Site Project<span className="required">*</span></label>
                                            {BillingType === "Single Site" ? (
                                                <>
                                                    <Select
                                                        options={projectOptions}
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        placeholder="Select Project"
                                                        onChange={handleProjectOptionsSingle}
                                                        value={projectOptions.find(opt => opt.value === projectId) || null}
                                                        styles={CSSForSelectModern}
                                                    />
                                                    {errors.projectId && <span className="error-message">{errors.projectId}</span>}
                                                </>
                                            ) : BillingType === "Multiple/All Sites" ? (
                                                <>
                                                    <Select
                                                        options={projectOptions}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        placeholder="Select Projects"
                                                        onChange={handleProjectOptions}
                                                        value={projectOptions.filter((opt) => projectIds?.includes(opt.value))}
                                                        styles={CSSForSelectModern}
                                                    />
                                                    {errors.projectIds && <span className="error-message">{errors.projectIds}</span>}
                                                </>
                                            ) : null}
                                        </div>
                                    )}

                                    {showPreviewTable && (
                                        <>
                                            <div className="form-field">
                                                <label><FileText size={14} /> Imprest Name<span className="required">*</span></label>
                                                <input
                                                    type="text"
                                                    name="imprest_name"
                                                    placeholder="Imprest Name"
                                                    value={ImprestName === "null" ? "" : ImprestName}
                                                    onChange={handleCommonChange}
                                                    className={errors.ImprestName ? "error" : inputState.imprest_name ? "success" : ""}
                                                />
                                                {errors.ImprestName && <span className="error-message">{errors.ImprestName}</span>}
                                            </div>

                                            <div className="form-field">
                                                <label><Clock size={14} /> Number of Days<span className="required">*</span></label>
                                                <input
                                                    type="number"
                                                    name="no_of_days"
                                                    placeholder="Days"
                                                    value={commonDays === "null" ? "" : commonDays}
                                                    onChange={handleCommonChange}
                                                    className={errors.commonDays ? "error" : inputState.no_of_days ? "success" : ""}
                                                />
                                                {errors.commonDays && <span className="error-message">{errors.commonDays}</span>}
                                            </div>

                                            <div className="form-field">
                                                <label><Calendar size={14} /> Imprest Date<span className="required">*</span></label>
                                                <input
                                                    type="date"
                                                    name="date"
                                                    value={commonDate === "null" ? "" : commonDate}
                                                    onChange={handleCommonChange}
                                                    className={errors.commonDate ? "error" : inputState.date ? "success" : ""}
                                                />
                                                {errors.commonDate && <span className="error-message">{errors.commonDate}</span>}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {showPreviewTable ? (
                                <div className="table-wrapper-minimal table-box scroll-container-table" style={{ marginTop: '16px' }}>
                                    <table className="progress-table-minimal">
                                        <thead className="table-heading">
                                            <tr>
                                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                                <th className="col-period" style={{ width: '18%' }}>Project</th>
                                                <th className="col-period text-center">Imprest / Bank Details</th>
                                                <th className="col-submitted text-center" style={{ width: '15%' }}>Requested Amount</th>
                                                <th className="col-approved text-center" style={{ width: '12%' }}>Staff / Days</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formData.map((item, index) => {
                                                const isExpanded = expandedRow === index;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr className="progress-row">
                                                            <td className="col-sno text-start">{index + 1}.</td>
                                                            <td className="col-period">
                                                                {item.project_code}<br />{item.project_short_name}
                                                            </td>
                                                            <td className="col-period">
                                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                                    <Landmark size={12} />
                                                                    <span>{item.bank_name || "-"}</span>
                                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                                </button>
                                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                                    {item.imprest_name || "-"}
                                                                </div>
                                                            </td>
                                                            <td className="col-submitted text-center">
                                                                <input
                                                                    type="number"
                                                                    name="fixed_imprest_amount"
                                                                    value={item.fixed_imprest_amount}
                                                                    onChange={(e) => handleInputChangee(e, index)}
                                                                    className="modern-select"
                                                                    style={{ width: '120px', textAlign: 'center' }}
                                                                />
                                                            </td>
                                                            <td className="col-approved text-center">
                                                                <span className="badge-value">{item.total_number_of_Office_staff || "-"} • {item.no_of_days || "-"}d</span>
                                                            </td>
                                                        </tr>

                                                        {isExpanded && (
                                                            <tr className="expanded-row">
                                                                <td colSpan={5}>
                                                                    <div className="expanded-content-attractive">
                                                                        <div className="expanded-content-header">
                                                                            <div className="expanded-content-title">
                                                                                <Sparkles size={13} />
                                                                                <span>Bank & Contact Details</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="stage-card submitted">
                                                                            <div className="stage-header">
                                                                                <Landmark size={14} />
                                                                                <span>Bank Details</span>
                                                                            </div>
                                                                            <div className="stage-content">
                                                                                <div className="stage-row"><span className="stage-label">Bank Name</span><span className="amount">{item.bank_name || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">Account Number</span><span className="amount">{item.account_number || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">Account Holder</span><span className="amount">{item.account_holder_name || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{item.ifsc_code || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">PAN Number</span><span className="amount">{item.pan_card || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">Mobile Number</span><span className="amount">{item.phone_number || "-"}</span></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="empty-state-attractive">
                                    <div className="empty-state-icon-wrap">
                                        <Filter size={32} />
                                    </div>
                                    <h4 className="empty-state-title">Select Criteria to Continue</h4>
                                    <p className="empty-state-subtitle">
                                        Choose a bill type and project to preview generated bills.
                                    </p>
                                </div>
                            )}

                            <div className="form-actions" style={{ marginTop: '16px' }}>
                                <div></div>
                                <div className="submit-buttons">
                                    <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading || !showPreviewTable}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Generating...' : 'Generate Bills'}</span>
                                    </button>
                                </div>
                            </div>

                            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                        </Modal.Body>
                    </Modal>
                </>
            )}
        </>
    );
};

const DeleteImprestDetails = ({ i, getData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);


    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Deleting: please wait...");
        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);


        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/imprestbankdetails/${i.id}/`
            );

            if (res.status === 200) {
                await getData();


                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Data deleted successfully.", {
                        autoClose: 1000,
                        pauseOnHover: true,
                        closeOnClick: true,
                    });
                }, 1000);
            } else {
                throw new Error("Unexpected response status: " + res.status);
            }

        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);

            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);

            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Imprest Details"
                className="model-delete-button-modern actionn-icon"
                style={{ backgroundColor: "#00000075" }}
                onClick={handleShow}
            >
                <DeleteDustbin modernButton="true" />
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
            ) : show === true && (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                    <Modal.Header className="modern-modal-header requirement-modal-header">
                        <div className="header-content">
                            <div className="requirement-header-icon">
                                <Trash2 size={22} />
                            </div>
                            <div>
                                <Modal.Title>Delete Imprest Details</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    This action cannot be undone
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                            <AlertCircle size={16} />
                            <span>
                                Are you sure you want to delete the imprest details of <strong>{i.siteproject_name}</strong>?
                            </span>
                        </div>

                        <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-primaryy"
                                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                                onClick={handleFormSubmitDelete}
                                disabled={loading}
                            >
                                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                                <span>{loading ? 'Deleting...' : 'Delete'}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const GetModalofImprestdetails = ({ imprestDetails, buffer, getData }) => {

    const [show, setShow] = useState(false);
    const [expandedRow, setExpandedRow] = useState(null);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setExpandedRow(null);
    }

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    return (
        <>
            <button title="View Imprest Details" className="btn-animated" onClick={handleShow}>
                <Wallet size={16} style={{ marginRight: "6px" }} /> View Imprest Details
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div style={{ color: "white" }}>
                            <Wallet size={24} />
                        </div>
                        <div>
                            <Modal.Title>Imprest Details</Modal.Title>
                            <p className="header-subtitle" style={{ color: "white" }}>Bank and imprest configuration by project</p>
                        </div>
                    </div>
                    <button className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body">
                    <div className="progress-modern-container">
                        <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <div className="stats-minimal-row">
                                <div className="stat-minimal-item">
                                    <Building2 size={14} />
                                    <span>Showing</span>
                                    <strong>{imprestDetails?.length || 0} projects</strong>
                                </div>
                            </div>
                        </div>

                        <div className="table-wrapper-minimal table-box scroll-container-table">
                            {buffer ? (
                                <div className="loader-minimal">
                                    <div className="spinner-minimal"></div>
                                </div>
                            ) : (
                                <table className="progress-table-minimal">
                                    <thead className="table-heading">
                                        <tr>
                                            <th className="col-sno" style={{ width: '6%' }}>#</th>
                                            <th className="col-period text-center">Project Details</th>
                                            <th className="col-submitted text-center">Total Staff</th>
                                            <th className="col-approved text-center">Fixed Imprest Amt.</th>
                                            <th className="col-action text-center" style={{ width: '14%' }}>Bank Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {imprestDetails?.length > 0 ? (
                                            imprestDetails.map((item, index) => {
                                                const isExpanded = expandedRow === index;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr className="progress-row">
                                                            <td className="col-sno text-start">{index + 1}.</td>
                                                            <td className="col-period text-center">
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                                    <span style={{ fontWeight: 600 }}>{item.siteproject_prcode}</span>
                                                                    <span style={{ fontSize: '11px', color: '#94a3b8' }}>{item.siteproject_name}</span>
                                                                </div>
                                                            </td>
                                                            <td className="col-submitted text-center">{item.total_number_officesite || "-"}</td>
                                                            <td className="col-approved text-center">
                                                                <span className="badge-value">
                                                                    {item?.fixed_imprest_amount ? `₹${formatCurrencyIndian(item.fixed_imprest_amount)}` : "-"}
                                                                </span>
                                                            </td>
                                                            <td className="col-action text-center">
                                                                <button className="period-trigger" style={{ margin: '0 auto' }} onClick={() => toggleRow(index)}>
                                                                    <Landmark size={12} />
                                                                    <span>Bank Info</span>
                                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                                </button>
                                                            </td>
                                                        </tr>

                                                        {isExpanded && (
                                                            <tr className="expanded-row">
                                                                <td colSpan={5}>
                                                                    <div className="expanded-content-attractive">
                                                                        <div className="expanded-content-header">
                                                                            <div className="expanded-content-title">
                                                                                <Landmark size={13} />
                                                                                <span>Bank Details</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="stage-card recommended" style={{ minWidth: '260px' }}>
                                                                            <div className="stage-content">
                                                                                <div className="stage-row"><span className="stage-label">Bank Name</span><span className="amount">{item.bank_name || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">Account Number</span><span className="amount">{item.account_number || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{item.ifsc_code || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">PAN No.</span><span className="amount">{item.pan_card || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">Account Holder Name</span><span className="amount">{item.account_holder_name || "-"}</span></div>
                                                                                <div className="stage-row"><span className="stage-label">Phone No.</span><span className="amount">{item.phone_number || "-"}</span></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={5}>
                                                    <div className="empty-state-attractive">
                                                        <div className="empty-state-icon-wrap">
                                                            <Wallet size={32} />
                                                        </div>
                                                        <h4 className="empty-state-title">No Imprest Details Found</h4>
                                                        <p className="empty-state-subtitle">There are no project imprest records to show yet.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export { AddUpdateImprestDetails, DeleteImprestDetails, GetModalofImprestdetails, AddImpresetBulkBilling }